import { createContext, useContext, useState } from "react";

const STORAGE_KEY = "tc_features";

const DEFAULTS = {
  ratingsEnabled: true,
  scoringEnabled: false,
};

function loadFlags() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return DEFAULTS;
    return { ...DEFAULTS, ...JSON.parse(stored) };
  } catch {
    return DEFAULTS;
  }
}

function saveFlags(flags) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(flags));
  } catch {}
}

const FeatureContext = createContext(null);

export function FeatureProvider({ children }) {
  const [flags, setFlags] = useState(loadFlags);

  function setFlag(key, value) {
    const next = { ...flags, [key]: value };
    setFlags(next);
    saveFlags(next);
  }

  return (
    <FeatureContext.Provider value={{ flags, setFlag }}>
      {children}
    </FeatureContext.Provider>
  );
}

export function useFeatures() {
  return useContext(FeatureContext);
}
